/**
 * Plays a video and loads it if it's not alrrady
 * 
 * @param video The video element.
 */
function play(video: HTMLVideoElement, callback?: () => void) {
    const playPromise = video.play();
    if(playPromise !== undefined) {
        playPromise.then(() => {
            if(callback) callback();
        }).catch();
    }
}

export function playVideo(video: HTMLVideoElement, callback?: () => void) {
    if(!video) return;

    if(video.readyState === 4) {
        play(video, callback);
    } else {
        
        // Plays the video due to loadeddata not firing in IE11
        // @ts-ignore
        if(!!window.MSInputMethodContext && !!document.documentMode) {
            play(video, callback);
        }

        // Load then play
        video.addEventListener('loadeddata', () => {
            play(video, callback);
        });
        video.load();
    }
}
